import React, { Component } from 'react';
import { Grid, Cell } from 'react-mdl';
import Education from './education';
import Experience from './experience';
import Experience2 from './experience2';
import Skills from './skills';


class Resume extends Component {
  render() {
    return(
      <div>
        <Grid>
          <Cell col={4}>
            <div style={{textAlign: 'center'}}>
              <img
                src={process.env.PUBLIC_URL + '/test.png'}
                alt="avatar"
                style={{height: '200px'}}
                 />
            </div>

            <h2 style={{paddingTop: '2em'}}>Minquan Li</h2>
            <h4 style={{color: 'grey'}}>Developer</h4>
            <hr style={{borderTop: '3px solid #833fb2', width: '50%'}}/>
            <p>Hello, I’m a CSUS graduate. My major is Computer Science and I enjoy all of my classes in my major. I like to think of myself as a developer because I like to create things that would benefit myself and others. My career goal is to be able to develop new software, games, and applications in the near future.</p>
            <hr style={{borderTop: '3px solid #833fb2', width: '50%'}}/>
            <h5>Phone</h5>
            <p>(916) 993-3679</p>
            <h5>Email</h5>
            <p>minquan.li@outlook.com</p>
            <h5>Website</h5>
            <p>limmil.github.io/portfolio</p>
            <h5>
              <a href="https://github.com/limmil/resume/raw/master/resume.pdf" rel="noopener noreferrer" target="_blank">
                Resume
              </a>
            </h5>
            <hr style={{borderTop: '3px solid #833fb2', width: '50%'}}/>
          </Cell>
          <Cell className="resume-right-col" col={8}>
            <h2>Education</h2>


            <Education
              startYear={2018}
              endYear={2019}
              schoolName="California State University, Sacramento"
              schoolDescription="Bachelor’s degree in Computer Science"
              GPA="Cumulative GPA: 3.13"
               />

               <Education
                 startYear={2014}
                 endYear={2017}
                 schoolName="Sierra College"
                 schoolDescription="Computer Science for Transfer: AS-T Degree"
                 GPA="Cumulative GPA: 3.11"
                  />
                <hr style={{borderTop: '3px solid #e22947'}} />

              <h2>Experience</h2>

            <Experience
              startYear={2014}
              endYear="2019"
              jobName="Computer Science Classes"
              school="Sierra College"
              description1="- One semester of system programming with C."
              description2="- Two semester of Java programming."
              description3="- RSA encryption with python."
              description4="- One semester of basic Linux commands."
              school2="Sacramento State University"
              description5="- One semester of Java programming with group project."
              description6="- Created a game with Codenameone in Java with Eclipse."
              description7="- One semester of data mining with Python"
              description8="- One semester of SQL"
              description9="- One semester of machine learning with Python"
              description10="- One semester of data visualization with Tableau Public and D3.js"
              />

              <Experience2
                startYear={2019}
                endYear="present"
                jobName="eCommerce Sales Manager"
                school="Collateral Money, Co."
                description1="Overseeing and driving the online sales growth of products. 
                Managing the day to day operation of the online store, 
                including product listing, pricing, and promotions. 
                Providing excellent customer service and technical support to ensure a positive shopping experience. 
                Developed reconciliation system using CRM to reconcile eCommerce sales with shop’s point of sales."
                />
              <hr style={{borderTop: '3px solid #e22947'}} />
              <h2>Skills</h2>
              <Skills
                skill="Java"
                progress={100}
                />
                <Skills
                  skill="C"
                  progress={70}
                  />
                  <Skills
                    skill="Python"
                    progress={80}
                    />
                    <Skills
                      skill="React"
                      progress={70}
                      />
                      <Skills
                        skill="JavaScript"
                        progress={75}
                        />


          </Cell>
        </Grid>
      </div>
    )
  }
}

export default Resume;
